import { accountState } from "./account/state";
import { BookingStoreNamespace } from "../../modules/booking/store";
import { AccountingStoreNamespace } from "../../modules/accounting/store";
import { SettingsStoreNamespace } from "../../modules/settings/store";

import { ArtistDetails, BookingDetails, PromoterDetails, TemplateDetails, VenueDetails } from "../../modules/booking/store/types";
import { CostsDetails, InvoiceDetails } from "../../modules/accounting/store/types";
import { ExternalUserDetails, InvoiceProjectDetails, NoticesDetails, UserDetails } from "../../modules/settings/store/types";
import { CatalogArtistsDetails, LabelDetails, ProductDetails, Product_groupDetails, ProjectDetails, ReleaseDetails, TrackDetails } from "../../modules/catalog/store/types";
import { CatalogStoreNamespace } from "../../modules/catalog/store";
import { AccountsDetails, ContractsDetails, StatementDetails } from "../../modules/royalty/store/types";
import {
  DistributionAccountDetails, DistributionOrderDetails, ShopDetails, Shop_groupDetails, SupplierDetails,
  DistributionStatementsDetails, DistributionReportDetails, DistributionSupplierOrderDetails
} from "../../modules/distribution/store/types";
import { RoyaltyStoreNamespace } from "../../modules/royalty/store";
import { LicenceStoreNamespace } from "../../modules/licensing/store";
import { DistributionStoreNamespace } from "../../modules/distribution/store";
import { LicenceAccountsDetails, LicenceDetails } from "../../modules/licensing/store/types";
import { ContactDetails, ContactGroupDetails } from "../../modules/contacts/store/types";
import { ContactStoreNamespace } from "../../modules/contacts/store";
import { i18n } from '../../i18n/index';
import { TaskStoreNamespace } from "../../modules/tasks/store";
import { TasksDetails } from "../../modules/tasks/store/task/types";
import { dtGPTState } from "./dtgpt/state";




export const state = {
  ...accountState,
  ...dtGPTState,
  
  miniVariant: false,
  clipped: false,
  drawer: true,
  fixed: true,
  mainNavActive: true,
  systemLanguages: [
    {
      locale: 'en',
      language: 'english'
    },
    {
      locale: 'de',
      language: 'german'
    },
    {
      locale: 'fr',
      language: 'french'
    },
    {
      locale: 'es',
      language: 'spanish'
    },
    {
      locale: 'it',
      language: 'italian'
    },
    {
      locale: 'pt',
      language: 'portuguese'
    },
    {
      locale: 'pl',
      language: 'polish',
    },
    // {
    //   locale: 'ru',
    //   language: 'Russian'
    // },
    // {
    //   locale: 'nl',
    //   language: 'Dutch'
    // },
    // {
    //   locale: 'tr',
    //   language: 'Turkish'
    // },
  ],
  systemLanguage: {
    locale: 'en',
    language: 'English',
    sections: ['main'],
    loadedSections: {}

  },
  appNavItems: [
    {
      title: 'Contacts',
      route: 'contacts',
      tkey: 'menu_Contacts',
      img: 'static/icons/nav/contacts.svg',
      store: ContactStoreNamespace,
      children: [
        { icon: 'video_label', title: 'Contacts', tkey: 'menu_Contacts', route: 'contact_list', default: true, DetailsAction: ContactDetails, primaryKey: 'contact_id' },
        { icon: 'video_label', title: 'Groups', tkey: 'submenu_GROUPS', route: 'groups', DetailsAction: ContactGroupDetails, primaryKey: 'group_id' },
        { icon: 'video_label', title: 'Files', tkey: 'submenu_documents', route: 'files' },
        { icon: 'video_label', tkey: 'submenu_Import_Export', title: 'Import/Export', route: 'Import_Export' },
      ],
    },
    {
      title: 'Tasks',
      route: 'task',
      tkey: 'menu_Tasks',
      img: 'static/icons/nav/tasks.svg',
      store: TaskStoreNamespace,
      children: [
        {
          tkey: 'submenu_tasks',
          icon: 'video_label', 
          title: 'Tasks',
          route: 'tasks',
          DetailsAction: TasksDetails,
          children: [],
          primaryKey: 'task_id'
        },
      ],
    },
    {
      title: 'Booking',
      route: 'booking',
      tkey: 'menu_Booking',
      img: 'static/icons/nav/booking.svg',
      store: BookingStoreNamespace,
      children: [
        { tkey: 'submenu_Calendar', title: 'Calendar', icon: 'video_label', route: 'calendar', default: true },
        {
          tkey: 'submenu_Booking List', title: 'Booking List', icon: 'book', route: 'booking_list',

          children: [],
          DetailsAction: BookingDetails,
          primaryKey: 'calendar_date_id'
        },
        { tkey: 'submenu_tasks', title: 'Tasks', icon: 'book', route: 'tasks' },
        { tkey: 'submenu_Requests', title: 'Requests', icon: 'video_label', route: 'requests', badge: 0 },
        { tkey: 'submenu_Booking Artists', title: 'Artists', icon: 'video_label', route: 'artists', DetailsAction: ArtistDetails, primaryKey: 'artist_id' },
        { tkey: 'submenu_Promoter', title: 'Promoters', icon: 'video_label', route: 'promoters', DetailsAction: PromoterDetails, primaryKey: 'promoter_id' },
        { tkey: 'submenu_Locations', title: 'Venues', icon: 'dvr', route: 'venues', DetailsAction: VenueDetails, primaryKey: 'venue_id' },
        { tkey: 'submenu_Templates', title: 'Templates', icon: 'video_label', route: 'templates', DetailsAction: TemplateDetails, primaryKey: 'booking_template_id' },
        { tkey: 'submenu_reports', title: 'Reports', icon: 'bar_chart', route: 'reports' },
        { tkey: 'submenu_TourMgmt', title: 'Tours', icon: 'video_label', route: 'tours' },
        { tkey: 'submenu_Plugins', title: 'Plugins', icon: 'settings', route: 'plugins' },
      ],
    },
    {title: 'Catalog',
      route: 'catalog',
      tkey: 'catalog',
      img: 'static/icons/nav/catalog.svg',
      store: CatalogStoreNamespace,
      children: [
        {
          tkey: 'submenu_Artists',
          icon: 'video_label', title: 'Artists', route: 'catalog_artists',
          DetailsAction: CatalogArtistsDetails,
          children: [],
          primaryKey: 'label_artist_id'
        },
        {
          tkey: 'submenu_Labels',
          icon: 'video_label', title: 'Labels', route: 'labels',
          DetailsAction: LabelDetails,
          children: [],
          primaryKey: 'label_id'
        },
        // {
        //   icon: 'video_label', title: 'Projects', route: 'projects',
        //   DetailsAction: ProjectDetails,
        //   children: [],
        //   primaryKey: 'project_id'
        // },
        {
          tkey: 'submenu_Releases',
          icon: 'video_label', title: 'Releases', route: 'releases',
          DetailsAction: ReleaseDetails,
          children: [],
          primaryKey: 'release_id',
          default: true
        },
        {
          tkey: 'submenu_Products',
          icon: 'video_label', title: 'Products', route: 'products',
          DetailsAction: ProductDetails,
          children: [],
          primaryKey: 'product_id',
        },
        {
          tkey: 'tab_title_product_groups',
          icon: 'video_label', title: 'Product Groups', route: 'product_groups',
          DetailsAction: Product_groupDetails,
          children: [],
          primaryKey: 'product_group_id'
        },
        {
          tkey: 'submenu_Tracks',
          icon: 'video_label', title: 'Tracks', route: 'tracks',
          DetailsAction: TrackDetails,
          children: [],
          primaryKey: 'track_id'
        },
        //{ icon: 'video_label', title: 'Reports', route: 'reports' },
        { icon: 'submenu_Plugins', title: 'Plugins', route: 'plugins' },

      ],
    },
    {title: 'Distribution',
      route: 'distribution',
      tkey: 'distribution',
      img: 'static/icons/nav/distribution.svg',
      store: DistributionStoreNamespace,
      children: [
        {
          tkey: "dashboard",
          icon: 'video_label', title: 'dashboard', route: 'dashboard', children: [],
        },
        {
          tkey: "submenu_Accounts",
          icon: 'video_label', title: 'Accounts', route: 'accounts',
          children: [],
          DetailsAction: DistributionAccountDetails,
          primaryKey: 'account_id',
          default: true
        },
        {
          tkey: "submenu_Statements In",
          icon: 'video_label', title: 'Imports', route: 'imports',
        },

        {
          tkey: "tab_title_statement_list",
          icon: 'video_label', title: 'Statement List', route: 'statement_list', children: [],
          DetailsAction: DistributionStatementsDetails,
          primaryKey: 'statement_id'
        },
        {
          tkey: "submenu_Orders",
          icon: 'video_label', title: 'Orders', route: 'orders', children: [],
          DetailsAction: DistributionOrderDetails,
          primaryKey: 'order_id'
        },
        {
          tkey: "submenu_Suppliers",
          icon: 'video_label', title: 'Suppliers', route: 'suppliers', children: [],
          DetailsAction: SupplierDetails,
          primaryKey: 'order_id'
        },
        {
          tkey: "tab_title_supplier_orders",
          icon: 'video_label',
          title: 'Supplier Orders',
          route: 'supplier_order',
          DetailsAction: DistributionSupplierOrderDetails,
          children: [],
          primaryKey: 'supplier_order_id'
        },

        {
          tkey: "submenu_Shops",
          icon: 'video_label', title: 'Shops', route: 'shops', children: [],
          DetailsAction: ShopDetails,
          primaryKey: 'shop_id'
        },
        {
          tkey: "tab_title_shop_groups",
          icon: 'video_label', title: 'Shop Groups', route: 'shop_groups', children: [],
          DetailsAction: Shop_groupDetails,
          primaryKey: 'shop_group_id'
        },
        {
          tkey: "submenu_reports",
          icon: 'video_label', title: 'Reports', route: 'reports', children: [],
          DetailsAction: DistributionReportDetails,
          primaryKey: 'order_id'
        },
        // {
        //   tkey: "release_report",
        //   icon: 'video_label', title: 'release_report', route: 'release_report', children: [],

        //   primaryKey: 'release_id'
        // },
        


        {
          tkey: "submenu_Plugins", icon: 'video_label', title: 'Plugins', route: 'plugins'
        },
      ],
    },
    {title: 'Licencing',
      route: 'licencing',
      tkey: 'submenu_Licensing',
      img: 'static/icons/nav/licensing.svg',
      store: LicenceStoreNamespace,
      children: [
        {
          tkey: "tab_title_licence_accounts",
          title: 'Licence Accounts', route: 'licence_accounts',
          DetailsAction: LicenceAccountsDetails,
          children: [],
          primaryKey: 'licence_account_id',
          default: true
        },
        {
          tkey: "licences",
          title: 'Licences', route: 'licences',
          DetailsAction: LicenceDetails,
          children: [],
          primaryKey: 'licence_id'
        },
        {
          tkey: "submenu_Plugins",
          title: 'Plugins', route: 'plugins'
        },
      ],
    },
    {title: 'royalty',
      route: 'royalty',
      tkey: 'royalty',
      img: 'static/icons/nav/royalty.svg',
      store: RoyaltyStoreNamespace,
      children: [
        {
          tkey: "royalty_accounts",
          title: 'Royalty Accounts', route: 'royalty_accounts',
          DetailsAction: AccountsDetails,
          children: [],
          primaryKey: 'royalty_account_id',
          default: true
        },
        {
          tkey: "contracts",
          title: 'Contracts', route: 'contracts',
          DetailsAction: ContractsDetails,
          children: [],
          primaryKey: 'contract_id'
        },
        {
          tkey: "royalty_statements",
          title: 'Royalty Statements', route: 'statements',
          DetailsAction: StatementDetails,
          children: [],
          primaryKey: 'royalty_period_id'
        },
        // { title: 'Statement Batches', route: 'statement_batches' },
        {
          tkey: "tab_title_recoupables", title: 'tab_title_recoupables', route: 'recoupable'
        },
        {
          tkey: "tab_title_checklist", title: 'Checklist', route: 'checklist'
        },
        // { title: 'Reports', route: 'reports' },
        {
          tkey: "submenu_Plugins", title: 'Plugins', route: 'plugins'
        },
      ],
    },
    // {
    //   title: 'Promotion',
    //   route: 'promotion',
    //   tkey: 'promotion',
    //   img: 'static/icons/nav/promotion.svg',
    //   children: [
    //     {
    //       tkey:"submenu_Promo Accounts",
    //       icon: 'video_label',
    //       title: 'Promotion Contacts',
    //       route: 'promotion_contacts',
    //     },
    //     {
    //       tkey:"submenu_Promo Groups", icon: 'video_label', title: 'Mailing Lists', route: 'mailing_lists' },
    //     {
    //       tkey:"tab_title_promotions", icon: 'video_label', title: 'Campaigns', route: 'campaigns' },
    //     {
    //       tkey:"submenu_Results", icon: 'video_label', title: 'Results', route: 'results' },
    //     {
    //       tkey:"submenu_Marketing", icon: 'video_label', title: 'Marketing', route: 'marketing' },
    //     {
    //       tkey:"submenu_Plugins", icon: 'video_label', title: 'Plugins', route: 'plugins' },
    //   ],
    // },
    // {
    //   title: 'Management',
    //   route: 'management',
    //   tkey: 'management',
    //   img: 'static/icons/nav/management.svg',
    //   children: [
    //     {tkey:"submenu_Artists", icon: 'video_label', title: 'Artists', route: 'artists' },
    //     {tkey:"submenu_Projects", icon: 'video_label', title: 'Projects', route: 'projects' },
    //     {tkey:"submenu_Plugins", icon: 'video_label', title: 'Plugins', route: 'plugins' },
    //   ],
    // },
    {
      title: 'Accounting',
      route: 'accounting',
      tkey: 'accounting',
      img: 'static/icons/nav/accounting.svg',
      store: AccountingStoreNamespace,
      children: [
        {
          tkey: 'submenu_Invoices',
          title: 'Invoices',
          route: 'invoices',

          children: [],
          DetailsAction: InvoiceDetails,
          primaryKey: 'invoice_id',
          default: true
        },
        { tkey: 'submenu_Invoice Reminder', title: 'Invoice Reminder', icon: 'video_label', route: 'invoice_reminders', },
        {
          tkey: 'submenu_costs', DetailsAction: CostsDetails, children: [], primaryKey: 'invoice_id',
          title: 'Costs', icon: 'video_label', route: 'costs'
        },
        { tkey: 'submenu_Accounting_Reports', title: 'Reports', icon: 'video_label', route: 'reports' },
        { tkey: 'submenu_Plugins', title: 'Plugins', icon: 'video_label', route: 'plugins' },
      ],
    },
    {
      title: 'Settings',
      route: 'settings',
      tkey: 'menu_Settings',
      img: 'static/icons/nav/settings.svg',
      store: SettingsStoreNamespace,
      children: [
        { tkey: 'submenu_General Settings', title: 'General', route: 'general', default: true },
        { tkey: 'submenu_Company Setup', title: 'Identities', route: 'identities', DetailsAction: InvoiceProjectDetails, primaryKey: 'invoice_project_id' },
        { tkey: 'submenu_User Setup', title: 'User', route: 'users', DetailsAction: UserDetails, primaryKey: 'user_id' },
        { tkey: 'external_user', title: 'External User', route: 'externalusers', DetailsAction: ExternalUserDetails, primaryKey: 'external_user_id' },
        { tkey: 'submenu_Booking Settings', title: 'Booking', route: 'booking' },
        { tkey: 'submenu_tasks', title: 'Task', route: 'task' },
        
        { tkey: 'submenu_Label Settings', title: 'Label', route: 'label' },
        { tkey: 'submenu_Promotion', title: 'Promotion', route: 'promotion' },
        { tkey: 'submenu_Accounting Settings', title: 'Accounting', route: 'accounting' },
        { tkey: 'submenu_Sharing', title: 'Sharing', route: 'sharing' },
        { tkey: 'submenu_Billing', title: 'Billing', route: 'billing' },
        // {
        //   tkey: 'submenu_Notices', title: 'Notices', route: 'notices',
        //   children: [],
        //   DetailsAction: NoticesDetails,
        //   primaryKey: 'client_notice_id'
        // },
        // { tkey: 'language', title: 'Language', route: 'language' },
        { tkey: 'submenu_custom_texts', title: 'Custom Texts', route: 'custom_texts' },
        { tkey: 'submenu_ai_settings', title: 'AI', route: 'ai' },
      ],
    },
  ],
  loginUser: {
    email: '',
    password: '',
    loading: false,
    success: false
  },
  loginRedirectRoute: {
    name: 'root',
    params: {},
    query: {}
  },
};
